import "@hotwired/turbo-rails"
import "../javascript/controllers"
import "../javascript/config/modal"
import "../javascript/config/flash"
import "../javascript/config/turbo_stream_actions"

import "./application.css"

console.log('Vite ⚡️')
